import { defineMessages } from 'react-intl';

export default defineMessages({
  epargnContituee: {
    id: 'releve_situation.epargn_contituee',
  },
  situationAu: {
    id: 'dashboard_epargn.situation_au',
  },
  tauxMinimum: {
    id: 'dashboard_epargn.taux_minimum',
  },
  epargnValorisee: {
    id: 'releve_situation.epargn_valorisee',
  },
  capitalGaranti: {
    id: 'dashboard_epargn.epargn_capital_garanti',
  },
  dateVersement: {
    id: 'acaps.date_versement',
  },
  versementPerYear: {
    id: 'acaps.versement_per_year',
  },
  primeType: {
    id: 'acaps.prime_type',
  },
  montantBrut: {
    id: 'acaps.montant_brut',
  },
  rachatsPerYear: {
    id: 'acaps.rachats_per_year',
  },
  rachatDate: {
    id: 'acaps.rachat_date',
  },
  irRachat: {
    id: 'acaps.ir_rachat',
  },
  irRachatTooltip: {
    id: 'acaps.ir_rachat.tooltip',
  },
  penaliteRachat: {
    id: 'acaps.penalite_rachat',
  },
  penaliteRachatTooltip: {
    id: 'acaps.penalite_rachat.tooltip',
  },
  rachatPartielNet: {
    id: 'acaps.rachat_partiel_net',
  },
  rachatPartielNetTooltip: {
    id: 'acaps.rachat_partiel_net.tooltip',
  },
  avancesPerYear: {
    id: 'acaps.avances_per_year',
  },
  dateOctroi: {
    id: 'acaps.date_octroi',
  },
  montantAvance: {
    id: 'acaps.montant_avance',
  },
  tauxRenumeration: {
    id: 'acaps.taux_remuneration',
  },
  dateEcheanceRemboursement: {
    id: 'acaps.date_echeance_remboursement',
  },
  montantAvanceNonRembourse: {
    id: 'acaps.montant_avance_non_rembourse',
  },
  avancesPerYeartooltip: {
    id: 'acaps.avances_per_year_tooltip',
  },
  rachatsPerYearTooltip: {
    id: 'acaps.rachats_per_year_tooltip',
  },
  versementPerYearTooltip: {
    id: 'acaps.versement_per_year_tooltip',
  },
});
